import { Spacing } from '@persona-id/design-tokens';
import { last } from 'lodash';
import { components, OptionProps } from 'react-select';
import styled from 'styled-components';

import AvailabilityCircle from 'dashboard/components-lib/AvailabilityCircle';
import { FormAssignCaseUserOption } from 'dashboard/forms/FormAssignCase/FormAssignCase';

const NAME_TRUNCATE_LENGTH = 32;

const StyledAvailabilityCircle = styled(AvailabilityCircle)`
  margin-left: ${Spacing[2]};
`;

const FormAssignCaseOption = (props: OptionProps<FormAssignCaseUserOption>) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const index = last(props.innerProps.id.split('-'));
  const id = props.selectProps.id != null ? `${props.selectProps.id}_${index}` : undefined;
  const onFocus = () => {
    props.selectProps.onFocusOption && props.selectProps.onFocusOption(props.data.value);
  };
  const getName = () => {
    let name = props.data.label;
    if (typeof props.data.label === 'string' && props.data.label.length > NAME_TRUNCATE_LENGTH) {
      name = props.data.label.substring(0, NAME_TRUNCATE_LENGTH) + '...';
    }
    if (props.data.isCurrentUser) {
      name += ' (Assign to me)';
    }
    return name;
  };

  return (
    <div onMouseOver={onFocus}>
      <components.Option {...props} innerProps={{ ...props.innerProps, id }}>
        {getName()}
        {props.data.availability && (
          <StyledAvailabilityCircle availability={props.data.availability} />
        )}
      </components.Option>
    </div>
  );
};

export default FormAssignCaseOption;
